export const StoreNames = {
    apiStatus: 'apiStatus',
    session: 'session',
    agentEnabledCompanies: 'agentEnabledCompanies',
    benefitCategoriesList: 'benefitCategoriesList',
    agentCompanyResources: 'agentCompanyResources',
    enrollmentManager: 'enrollmentManager',
}
